exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ModulesList__container{font:var(--main-font)}", ""]);

// exports
exports.locals = {
	"container": "ModulesList__container"
};